import React from 'react';
import './CryptoSelector.css';

const CryptoSelector = ({ onSelectCrypto }) => {
  const cryptos = [
    { id: 'polygon', name: 'Polygon', symbol: 'POL', icon: '/POL_polygon.png', color: '#8247e5', outOfStock: false },
    { id: 'trc20', name: 'USDT TRC20', symbol: 'TRC20', icon: '/USDTtron.png', color: '#1dd1a1', outOfStock: false },
    { id: 'erc20', name: 'USDT ERC20', symbol: 'ERC20', icon: '/ETHerc20.png', color: '#627eea', outOfStock: false },
    { id: 'bep20', name: 'USDT BEP20', symbol: 'BEP20', icon: '/Binancebep20.webp', color: '#f3ba2f', outOfStock: false }
  ];

  return (
    <section className="crypto-selector">
      <div className="container">
        <h2>Choose Your <span className="highlight">USDT</span></h2>
        <p className="subtitle">Select your preferred blockchain network</p>
        
        <div className="crypto-grid">
          {cryptos.map((crypto) => (
            <div 
              key={crypto.id} 
              className={`crypto-card ${crypto.outOfStock ? 'out-of-stock' : ''}`}
              onClick={() => onSelectCrypto(crypto)}
            >
              {crypto.outOfStock && (
                <div className="stock-badge">
                  <span className="badge-dot"></span>
                  Out of Stock
                </div>
              )}
              <div className="crypto-icon">
                <img src={crypto.icon} alt={crypto.name} />
              </div>
              <h3>{crypto.name}</h3>
              <button className="select-btn" style={{ background: crypto.color }}>
                {crypto.symbol}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CryptoSelector;
